import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String,
    label: { type: String, default: "Link copied" },
  }

  async copy(event) {
    event.preventDefault()
    const text = this.textValue
    if (!text) return

    if (this.shouldUseNativeShare()) {
      try {
        await navigator.share({ url: text, title: document.title })
        return
      } catch (error) {
        if (error.name === "AbortError") return
      }
    }

    const copied = await this.writeToClipboard(text)
    if (copied) {
      this.showToast(this.labelValue)
    } else {
      this.showToast("Couldn't copy link", "alert")
    }
  }

  shouldUseNativeShare() {
    return navigator.share && window.matchMedia("(pointer: coarse)").matches
  }

  async writeToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      try {
        const input = document.createElement("textarea")
        input.value = text
        input.setAttribute("readonly", "")
        input.style.position = "absolute"
        input.style.left = "-9999px"
        document.body.appendChild(input)
        input.select()
        const ok = document.execCommand("copy")
        input.remove()
        return ok
      } catch {
        return false
      }
    }
  }

  showToast(message, kind = "notice") {
    let banner = document.querySelector(".flash-banner")
    if (!banner) {
      banner = document.createElement("div")
      banner.className = "flash-banner"
      banner.setAttribute("role", "status")
      document.body.appendChild(banner)
    }

    const toast = document.createElement("div")
    toast.className = `flash-toast flash-toast--${kind}`
    toast.setAttribute("role", "status")

    const text = document.createElement("p")
    text.className = "flash-toast__message"
    text.textContent = message
    toast.appendChild(text)

    const dismiss = document.createElement("button")
    dismiss.type = "button"
    dismiss.className = "flash-toast__dismiss"
    dismiss.setAttribute("aria-label", "Dismiss")
    dismiss.textContent = "×"
    dismiss.addEventListener("click", () => toast.remove())
    toast.appendChild(dismiss)

    banner.appendChild(toast)
    window.setTimeout(() => toast.remove(), 4000)
  }
}
